import { FC } from "react";
import { LoadingSpinner } from "components";
import { useBucketContext } from "context/bucket";
import { useEffect, useState } from "react";
import { Table, List } from "./components";
import { useScreenDetector } from "hooks";
import { useAppDispatch } from "redux/store";
import { showErrorModal } from "redux/slices";
import {
  DeleteModalConfig,
  RenameModalConfig,
  ModalConfig,
  PreviewModalConfig,
} from "./types";
import { DeleteModal, MoveModal, RenameModal, EmptyPage } from "./components";
import { PreviewModal } from "./components/previewModal";

export const ContentController: FC = () => {
  const [deleteModalConfig, setDeleteModalConfig] =
    useState<DeleteModalConfig | null>(null);
  const [moveModalConfig, setMoveModalConfig] = useState<ModalConfig | null>(
    null
  );
  const [renameModalConfig, setRenameModalConfig] =
    useState<RenameModalConfig | null>(null);
  const [previewModalConfig, setPreviewModalConfig] =
    useState<PreviewModalConfig | null>(null);

  const { apiHandler, fetchHomePageData, loading, content, breadcrumb } =
    useBucketContext();
  const dispatch = useAppDispatch();
  const { isMobileScreen } = useScreenDetector();

  const handleFetch = async () => {
    const result = await fetchHomePageData(breadcrumb);
    !result &&
      dispatch(
        showErrorModal({
          text: "Qualcosa è andato storto, esegui nuovamente l'operazione",
        })
      );
  };

  useEffect(() => {
    apiHandler(handleFetch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleShowDeleteModal = (config: DeleteModalConfig) =>
    setDeleteModalConfig(config);

  const handleCloseDeleteModal = () => setDeleteModalConfig(null);

  const handleShowMoveModal = (config: ModalConfig) =>
    setMoveModalConfig(config);

  const handleCloseMoveModal = () => setMoveModalConfig(null);

  const handleShowRenameModal = (config: RenameModalConfig) => {
    setRenameModalConfig(config);
  };

  const handleCloseRenameModal = () => {
    setRenameModalConfig(null);
  };

  const handleShowPreviewModal = async (config: PreviewModalConfig) => {
    setPreviewModalConfig(config);
    // await getPresignedUrl(filename);
  };

  const handleClosePreviewModal = () => {
    setPreviewModalConfig(null);
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return content?.folderList.length || content?.fileList.length ? (
    <>
      {isMobileScreen ? (
        <List
          fileList={content?.fileList}
          folderList={content?.folderList}
          showRemoveModal={handleShowDeleteModal}
          showRenameModal={handleShowRenameModal}
          showMoveModal={handleShowMoveModal}
          showPreviewModal={handleShowPreviewModal}
        />
      ) : (
        <Table
          fileList={content?.fileList}
          folderList={content?.folderList}
          showRemoveModal={handleShowDeleteModal}
          showRenameModal={handleShowRenameModal}
          showMoveModal={handleShowMoveModal}
          showPreviewModal={handleShowPreviewModal}
        />
      )}
      <PreviewModal
        config={previewModalConfig}
        onClose={handleClosePreviewModal}
      />
      <RenameModal
        config={renameModalConfig}
        onClose={handleCloseRenameModal}
      />
      <MoveModal config={moveModalConfig} onClose={handleCloseMoveModal} />
      <DeleteModal
        config={deleteModalConfig}
        onClose={handleCloseDeleteModal}
      />
    </>
  ) : (
    <EmptyPage />
  );
};
